var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      class: [
        this.productIsOnSale
          ? "price--on-sale price price--listing"
          : "price price--listing"
      ]
    },
    [
      _c(
        "dl",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value:
                _vm.data.comparePrice &&
                _vm.data.comparePrice !== _vm.data.price,
              expression:
                "data.comparePrice && data.comparePrice !== data.price"
            }
          ],
          staticClass: "price__sale"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c("dd", { staticClass: "price__compare meta" }, [
            _c("s", { staticClass: "price-item price-item--regular meta" }, [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.data.comparePrice) +
                  "\n            "
              )
            ])
          ]),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _vm._m(2),
          _c("dd", [
            _c(
              "span",
              { staticClass: "price-item price-item--sale accent meta" },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.data.price) +
                    "\n                "
                )
              ]
            )
          ]),
          _vm._v(" "),
          _c("dt"),
          _vm._v(" "),
          _c("dd", [
            _c("span", { staticClass: "price-item price-item--sale accent" }),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "price-item price-item--sale",
                staticStyle: { color: "rgb(109, 155, 167)" }
              },
              [_vm._v(_vm._s(_vm.data.percentOff) + "% OFF")]
            )
          ])
        ]
      ),
      _vm._v(" "),
      _vm._m(3),
      _vm._v(" "),
      _c("dl", { staticClass: "price__regular" }, [
        _vm._m(4),
        _vm._v(" "),
        _c("dd", [
          _c("span", { staticClass: "price-item price-item--regular meta" }, [
            _vm._v("\n            " + _vm._s(_vm.data.price) + "\n            ")
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", { staticClass: "price__compare meta" }, [
      _c("span", { staticClass: "visually-hidden visually-hidden--inline" }, [
        _vm._v("\n                Regular price\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [
      _c("span", { staticClass: "visually-hidden visually-hidden--inline" }, [
        _vm._v("\n                Sale price\n            ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dd", [
      _c("dt", [
        _c("span", { staticClass: "visually-hidden visually-hidden--inline" }, [
          _vm._v("Regular price")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [
      _c("span", { staticClass: "visually-hidden visually-hidden--inline" }, [
        _vm._v("\n            Sale price\n        ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("dt", [
      _c("span", { staticClass: "visually-hidden visually-hidden--inline" }, [
        _vm._v("Regular price")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }